module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('form', {
    on: {
      "submit": _vm.createWorkflowAttribute
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h5', [_vm._v("Information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-text', {
    ref: "name",
    attrs: {
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.workflowAttribute.name),
      callback: function($$v) {
        _vm.$set(_vm.workflowAttribute, "name", $$v)
      },
      expression: "workflowAttribute.name"
    }
  }), _vm._v(" "), _c('form-select', {
    ref: "type",
    attrs: {
      "label": "Type",
      "name": "type",
      "options": _vm.inputTypes,
      "validation": "required"
    },
    model: {
      value: (_vm.workflowAttribute.type),
      callback: function($$v) {
        _vm.$set(_vm.workflowAttribute, "type", $$v)
      },
      expression: "workflowAttribute.type"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-checkbox', {
    attrs: {
      "label": "Active",
      "name": "active"
    },
    model: {
      value: (_vm.workflowAttribute.active),
      callback: function($$v) {
        _vm.$set(_vm.workflowAttribute, "active", $$v)
      },
      expression: "workflowAttribute.active"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5858084a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/WorkflowAttributes/CreateWorkflowAttribute.vue
// module id = 629
// module chunks = 1